module.exports = __webpack_public_path__ + "assets/notifications.6e109b38.svg";